module.exports = __webpack_public_path__ + "img/ScaleIcon.ddf69a29.svg";